<template>
    <div style="display: inline-block" v-if="isQuizActive==true">
        <router-link :to="{ name: 'Statistik'}">
            <font-awesome-icon icon="trophy" size="lg" class="topicon"/>
            <span class="toppercent">{{prozente}}</span>
        </router-link>
    </div>
</template>
<script type="text/babel">
    export default {
        name: 'PunkteCounterTop',
        data() {
            return {
                //currentroute: null,

            }
        },
        computed: {
            isQuizActive: function () {


                return this.$root.solvedQuizes.length > 0;


            },
            prozente: function () {
                let antworten = this.$root.solvedQuizes.length;

                if (antworten == 0) return '-- %';

                let punktePlus = 0;

                this.$root.solvedQuizes.forEach((element, index) => {
                    if (element.answerRight === true) {
                        punktePlus++;
                    }
                });

                let prozent= punktePlus/antworten*100;

                return prozent.toFixed(2) + '%';

            },
            punktePostitiv: function () {
                // this.$root.solvedQuizes
                let punkte = 0;
                this.$root.solvedQuizes.forEach((element, index) => {
                    if (element.answerRight === true) {
                        punkte++;
                    }
                });

                return punkte;

            },
            punkteNegativ: function () {
                // this.$root.solvedQuizes
                let punkte = 0;
                this.$root.solvedQuizes.forEach((element, index) => {
                    if (element.answerRight === false) {
                        punkte++;
                    }
                });

                return punkte;

            },
            zeit: function () {
                let zeit = 0.0;
                this.$root.solvedQuizes.forEach((element, index) => {
                    //console.log(element);
                    let ed = new Date(element.endDate);
                    let sd = new Date(element.startDate);
                    zeit += (ed.getTime() - sd.getTime()) / 1000;

                });

                return zeit.toFixed(2) + ' Sekunden';

            }
        },


    }
</script>

<style lang="scss" scoped>
    .topicon {
        color: white;
        margin-left: 20px
    }

    .toppercent {
        margin-left: 10px;
        color: white;
    }

    #top {
        border-radius: 9999px;
        padding: 5px;
        background-color: #eee;
        color: #000;
    }
</style>